import React from 'react';

// Import images
import bannerShape1 from '../../assets/images/shapes/banner-one-shape-1.png';
import bannerShape2 from '../../assets/images/shapes/banner-one-shape-2.png';
import bannerImg1 from '../../assets/images/artwer/project-1-balkon-hilversum-hero.jpg';
import bannerImg1Webp from '../../assets/images/artwer/project-1-balkon-hilversum-hero.webp';
import bannerImg2 from '../../assets/images/artwer/project-3-galerij-amsterdam-hero.jpg';
import bannerImg2Webp from '../../assets/images/artwer/project-3-galerij-amsterdam-hero.webp';
import bannerImg3 from '../../assets/images/artwer/project-6-vloercoating-amsterdam-hero.jpg';
import bannerImg3Webp from '../../assets/images/artwer/project-6-vloercoating-amsterdam-hero.webp';
import bannerImgShape from '../../assets/images/shapes/banner-one-img-shape-1.png';

const Banner = () => {
  return (
    <section className="banner-one" id="home">
      <div
        className="banner-one__shape-1 float-bob-y"
        style={{ backgroundImage: `url(${bannerShape1})` }}
      ></div>
      <div className="banner-one__shape-2 float-bob-x">
        <img src={bannerShape2} alt="" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
            <div className="banner-one__left">
              <div className="banner-one__title-box">
                <p className="banner-one__sub-title">Aannemingsbedrijf · sinds 2012</p>
                <h1 className="banner-one__title">
                  Uw balkons en galerijen, <br />
                  <span className="color-text">vakkundig</span>{' '}
                  <span className="normal-text">hersteld.</span>
                </h1>
              </div>
              <p className="banner-one__text">
                <span className="nowrap">ART-WER</span> is een eenmanszaak, actief sinds 2012 in balkons, galerijen en
                betonherstel. U praat van begin tot eind met dezelfde persoon — degene die de
                offerte maakt, het werk uitvoert en bij de oplevering naast u staat.
              </p>
              <ul className="list-unstyled banner-one__points">
                <li>
                  <div className="banner-one__single">
                    <div className="banner-one__icon">
                      <span className="icon-wall"></span>
                    </div>
                    <div className="banner-one__content">
                      <p className="banner-one__point-title">
                        <a href="#over">U praat met de vakman zelf</a>
                      </p>
                      <p>Geen verkoper, geen tussenpersoon</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="banner-one__single">
                    <div className="banner-one__icon">
                      <span className="icon-tools"></span>
                    </div>
                    <div className="banner-one__content">
                      <p className="banner-one__point-title">
                        <a href="#werkwijze">Garantie op uitvoering</a>
                      </p>
                      <p>Met fabrieksgarantie van Soprema ALSAN®</p>
                    </div>
                  </div>
                </li>
              </ul>
              <div className="banner-one__btn-box">
                <a href="#contact" className="thm-btn-two banner-one__btn">
                  Plan een opname<span className="icon-dubble-arrow-right"></span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-6 wow fadeInRight" data-wow-delay="400ms">
            <div className="banner-one__right">
              <ul className="list-unstyled banner-one__img-list">
                <li>
                  <div className="banner-one__img-list-single">
                    <div className="banner-one__img">
                      <picture>
                        <source srcSet={bannerImg1Webp} type="image/webp" />
                        <img src={bannerImg1} alt="Balkonrenovatie met Soprema ALSAN PMMA in Hilversum" width="615" height="820" fetchpriority="high" />
                      </picture>
                      <div
                        className="banner-one__img-shape-1"
                        style={{ backgroundImage: `url(${bannerImgShape})` }}
                      ></div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="banner-one__img-list-single">
                    <div className="banner-one__img">
                      <picture>
                        <source srcSet={bannerImg2Webp} type="image/webp" />
                        <img src={bannerImg2} alt="Opgeleverde galerijvloer in Amsterdam" width="820" height="615" />
                      </picture>
                      <div
                        className="banner-one__img-shape-1"
                        style={{ backgroundImage: `url(${bannerImgShape})` }}
                      ></div>
                    </div>
                    <div className="banner-one__img mt-12">
                      <picture>
                        <source srcSet={bannerImg3Webp} type="image/webp" />
                        <img src={bannerImg3} alt="Vloercoating technische ruimte in Amsterdam" width="615" height="820" />
                      </picture>
                      <div
                        className="banner-one__img-shape-1"
                        style={{ backgroundImage: `url(${bannerImgShape})` }}
                      ></div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
